<div class="setting-page">
  <legend>Global Routing Settings</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="isUnauthorized">
    <arm-form-title>routing attempts</arm-form-title>
    <div class="settings-section">
      <div class="routing-settings">
        <mat-form-field class="sixtyPerWidth">
          <mat-label>Maximum number of routing attempts</mat-label>
          <input matInput [(ngModel)]="routingSettings.maxRoutes" type="number" min="1" max="10" name="maxRoutes" required>
        </mat-form-field>

        <mat-form-field class="sixtyPerWidth">
          <mat-label>Maximum routes per Peer Connection</mat-label>
          <input matInput [(ngModel)]="routingSettings.maxRoutesPerAction" type="number" min="1" max="10" name="maxRoutesPerAction" required>
        </mat-form-field>

        <mat-form-field class="sixtyPerWidth">
          <mat-label>Maximum routes per Voip Peer</mat-label>
          <input matInput [(ngModel)]="routingSettings.maxRoutesPerVoippeer" type="number" min="1" max="10" name="maxRoutesPerVoippeer" required>
        </mat-form-field>
      </div>
    </div>

    <arm-form-title>calls</arm-form-title>
    <div class="settings-section">
      <mat-form-field class="sixtyPerWidth">
        <mat-label>Maximum number of unselected rules to be shown</mat-label>
        <input matInput [(ngModel)]="routingSettings.maxUnselectedRulesToBeShown" type="number"
               min="1" max="25" name="maxUnselectedRulesToBeShown" required>
      </mat-form-field>
    </div>

    <arm-form-title>source peer connection to use</arm-form-title>
    <div class="settings-section">
      <mat-form-field class="sixtyPerWidth">
        <mat-label>REFER request</mat-label>
        <mat-select [(ngModel)]="routingSettings.enableRerouteGroupOfRefer" name="refer">
          <mat-option *ngFor="let item of enableRerouteGroupTypesOptions" [value]="item.value">
            {{item.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="sixtyPerWidth">
        <mat-label>3XX request</mat-label>
        <mat-select [(ngModel)]="routingSettings.enableRerouteGroupOf3XX" name="3xx">
          <mat-option *ngFor="let item of enableRerouteGroupTypesOptions" [value]="item.value">
            {{item.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

  </arm-form>


</div>
